module.exports = __webpack_public_path__ + "img/tag3.b3ef9cbb.png";